(function () {
  angular
    .module("akitabox.mobile.directives.listItem", ["akitabox.core"])
    .directive("abmListItem", AbmListItemDirective);

  /**
   * @ngdoc directive
   * @module akitabox.directives.listItem
   * @name AbmListItemDirective
   *
   * @restrict E
   *
   * @description
   * `<abm-list-item>` wraps around a two-line material design md-list-item.
   * The inner elements are transcluded into the md-list-item.
   *
   * @usage
   * <hljs lang="html">
   *
   * <abm-list-item icon="{angular-material icon name}">
   *   <p class="abm-mobile-list-item-title">{Title}</p>
   *   <p class="abm-mobile-list-item-subtitle">{Subtitle}</p>
   * </abm-list-item>
   *
   * </hljs>
   */
  function AbmListItemDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/list-item/list-item.html",
      transclude: true,
    };
  }
})();
